import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a1efcc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ub ub-ver fw" }

export function render(_ctx, _cache) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_tabs = _resolveComponent("a-tabs")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: _ctx.activeKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => ((_ctx.activeKey) = $event)),
      "tab-position": _ctx.mode,
      onChange: _ctx.changeTab
    }, {
      rightExtra: _withCtx(() => [
        _renderSlot(_ctx.$slots, "rightButton", {}, () => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onChangeBtn
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.showBtn?'切换为仓库视角':'切换为项目视角'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ], true)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsArr, (item, index) => {
          return (_openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.code,
            tab: item.name + '(' + item.total + ')'
          }, null, 8, ["tab"]))
        }), 128))
      ]),
      _: 3
    }, 8, ["activeKey", "tab-position", "onChange"])
  ]))
}